import type { PaymentTypes } from 'pages/productPlans/CreateProductPage/types';

import type { UserDetails } from 'components/PreviewScreen/types';

export interface PRODUCT_FOR_PREVIEW {
    payment_type: PaymentTypes | '';
    id: string;
    name: string;
    content_id: string;
    period?: number | null;
    trial?: number | null;
    is_preselected: boolean;
    product_state: number | 'full';
    location: string;
    product_code: string;
    start_price_per_state?: number;
    price_per_state?: number;
    start_price?: number;
    price?: number;
    sign: string;
    code: string;
    rate: number;
    without_rate_intro_price?: number;
    without_rate_full_price?: number;
    vat_enabled: boolean;
    position?: number;
    feature_sets: number;
    type: string;
    without_rate_intro_price_per_state?: number;
    without_rate_full_price_per_state?: number;
    ltv: number;
    campaign_id?: number | null;
}

export const DEVICE = {
    mobile: {
        default: {
            width: 390,
            height: 724,
            deviceName: 'Iphone 12',
        },
        //     iphone 13,14,15...
    },
    desktop: {
        default: {
            width: 390,
            height: 724,
        },
    },
};

export const PREVIEW_USER_DETAILS: UserDetails = {
    weight: 75,
    height: 175,
    age: 50,
    gender: 'female',
    lang: 'en',
    country: 'US',
    theme_id: 0,
};

export const LOCAL_STORAGE_TIMER_FIELD = 'timer-screen-11111';
export const STORAGE_NAME = '_wflib';
export const COOKIE_EXPIRY_DAYS = 7;
